var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBluebgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 30.0866C8.63596 30.0866 2.66663 24.1173 2.66663 16.7533C2.66663 9.39059 8.63596 3.41992 16 3.41992C23.364 3.41992 29.3333 9.39059 29.3333 16.7533C29.3333 24.1173 23.364 30.0866 16 30.0866ZM16 10.0866C15.6463 10.0866 15.3072 10.2271 15.0571 10.4771C14.8071 10.7272 14.6666 11.0663 14.6666 11.4199V18.0866C14.6666 18.4402 14.8071 18.7793 15.0571 19.0294C15.3072 19.2794 15.6463 19.4199 16 19.4199C16.3536 19.4199 16.6927 19.2794 16.9428 19.0294C17.1928 18.7793 17.3333 18.4402 17.3333 18.0866V11.4199C17.3333 11.0663 17.1928 10.7272 16.9428 10.4771C16.6927 10.2271 16.3536 10.0866 16 10.0866ZM16 23.4199C16.3536 23.4199 16.6927 23.2794 16.9428 23.0294C17.1928 22.7793 17.3333 22.4402 17.3333 22.0866C17.3333 21.733 17.1928 21.3938 16.9428 21.1438C16.6927 20.8937 16.3536 20.7533 16 20.7533C15.6463 20.7533 15.3072 20.8937 15.0571 21.1438C14.8071 21.3938 14.6666 21.733 14.6666 22.0866C14.6666 22.4402 14.8071 22.7793 15.0571 23.0294C15.3072 23.2794 15.6463 23.4199 16 23.4199Z",
    fill: "#4776E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBluebgInfo);
export default __webpack_public_path__ + "static/media/ic-bluebg-info.8205309eaffcd48a723dfdb941f06841.svg";
export { ForwardRef as ReactComponent };